"use strict"

import React from "react"
import { OverlayTrigger, Popover } from "react-bootstrap"

import ObservationKeyMarker from "../../GraphKeys/ObservationKeyMarker"
import TrendEditor from "./TrendEditor"

export default function TrendEditorPopover({
  observations,
  obs,
  plotConfigUpdater,
  spacing,
  graphKey,
  tag_category,
  graphIndex,
  intl,
}) {
  return (
    <OverlayTrigger
      trigger="click"
      placement="bottom"
      rootClose
      overlay={
        <Popover id="trendEditor">
          <Popover.Body>
            <TrendEditor
              obs={obs}
              intl={intl}
              observations={Object.assign([], observations)}
              tag_category={tag_category}
              graph={graphKey}
              graphIndex={graphIndex}
              plotConfigUpdater={plotConfigUpdater}
            />
          </Popover.Body>
        </Popover>
      }
    >
      <g
        transform={`translate(10, ${spacing / 2})`}
        style={{
          cursor: "pointer",
          opacity: "" + (obs.disabled ? "0.45" : "1.0"),
        }}
      >
        <ObservationKeyMarker {...obs} />
      </g>
    </OverlayTrigger>
  )
}
